import { mapState } from 'vuex'

import Icon from '@/components/icon'

export default {
  components: {
    appIcon: Icon
  },
  computed: {
    ...mapState('tours', ['agent', 'multiAgents', 'ready']),
    logo () {
      if (this.ready) {
        return this.agent.logo && this.agent.logo[0].urls[0].url
      }
    },
    avatar () {
      if (this.ready) {
        return this.agent.avatar && this.agent.avatar[0].urls[0].url
      }
    }
  }
}
